import ForgotPassword from "../components/forgotpass";

function ForgotPass(){
    return(
        <ForgotPassword />
    )
}
export default ForgotPass;